import PageLayout from 'pages/CreateRubricManual/PageLayout';
import PageProvider from 'pages/EditRubric/PageProvider';

const EditRubricPage = ({ ...props }) => {
    return (
        <PageProvider {...props}>
            <PageLayout {...props} />
        </PageProvider>
    );
};

export default EditRubricPage;
